import Projects from './components/Projects'
import './App.css'

const App = () => <Projects />

export default App
